import React from "react";
import { Container, Navbar } from "react-bootstrap";
import LogoHeader from "../assets/LogoIPC.svg";
import iconoPresupuestar from "../assets/presup-ico.png";

const MenuHeader = () => {
  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <a href="https://piscinasipc.com/" target="_blank">
            <img src={LogoHeader} alt="Piscinas IPC" id="logoHeader"></img>
          </a>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <a
          href="https://piscinasipc.com/cotizador"
          target="_blank"
          className="box"
          rel="noreferrer"
        >
          <span>
            <img src={iconoPresupuestar} alt="Piscinas IPC"></img> Presupuestar
          </span>
          <i></i>
        </a>
      </Container>
    </Navbar>
  );
};

export default MenuHeader;
